import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import NavbarMob from "../components/NavbarMob";
import loc from "../images/details/loc.png";
import dinner from "../images/details/Dinner.png";
import rs from "../images/details/rs.png";
import phone from "../images/details/phone.png";
import id from "../images/details/ID.png";
import suitecase from "../images/details/Suitcase.png";
import company from "../images/details/Company.png";
import wa from "../images/details/whatsapp.png";
import mail from "../images/details/mailpng.png";
import fb from "../images/details/Facebook.png";
import insta from "../images/details/insta.png";
import x from "../images/details/x.png";
import telegram from "../images/details/telegram.png";
import Footer from "../components/Footer";
import Navbar2 from "../components/Navbar2";
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";
import poster from "../images/download/Poster2.png";
import Navbar2Mob from "../components/Navbar2Mob";

function DetailsForStaff() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const [jobDetails, setJobDetails] = useState(null); // State to store job details
    const [error, setError] = useState(null); // State to handle errors
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL; // Assuming you have this in .env file

    const location = useLocation();
    const { jobId } = location.state || {}; // Extract jobId from state
    // console.log("jobId:", jobId);

    const jobIdStr = jobId.toString();

    const customerType = sessionStorage.getItem("customerType");

    const navigate = useNavigate();
    const selectedPlan = sessionStorage.getItem("selectedPlan");
    const companyName = sessionStorage.getItem("customerName");
    const mobileNumber = sessionStorage.getItem("mobileNumber");
    const whatsappNumber = sessionStorage.getItem("whatsappNumber");
    const address = sessionStorage.getItem("address");
    const uppercaseAddress = address ? address.toUpperCase() : null;
    // console.log("uppercaseaddress", uppercaseAddress);

    const Email = sessionStorage.getItem("Email");

    // const employeeId = sessionStorage.getItem('employeeId');
    // console.log("selectedPlan:", selectedPlan);
    // console.log("employeeId:", employeeId);
    const handlePackageClick = () => {
        if (!customerType) {
            alert("Please login first"); // Alert if not logged in
            return; // Exit the function
        }

        // Check if the customer is an admin
        if (customerType === "admin" || customerType === "mainAdmin") {
            navigate("/companydetails", { state: { employeeId: jobDetails.employee_id } });
            return; // Exit the function after navigating to company details
        }

        // Proceed with the existing logic for selected plans
        if (["300", "500", "600", "800", "0"].includes(selectedPlan)) {
            navigate("/companydetails", { state: { employeeId: jobDetails.employee_id } });
        } else {
            navigate("/packages", {
                state: {
                    job: jobDetails.job,
                    jobId:
                        jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                            ? jobDetails.manualJobID
                            : jobDetails.job_id,
                    location: jobDetails.location,
                },
            });
        }
    };

    // Assuming 'selectedPlan', 'jobDetails', and 'customerName' are available in the component's scope
    const Packages2 = async () => {
        if (!customerType) {
            alert("Please login first"); // Alert if not logged in
            return; // Exit the function
        }
        if (
            selectedPlan === "300" ||
            selectedPlan === "500" ||
            selectedPlan === "600" ||
            selectedPlan === "800" ||
            selectedPlan === "0"
        ) {
            try {
                // Prepare data to send to the backend
                const payload = {
                    employeeId: jobDetails.employee_id,
                    customerName: companyName,
                    jobId: jobDetails.job_id,
                    whatsappNumber: whatsappNumber,
                    mobileNumber: mobileNumber,
                    Email: Email,
                };

                // Send data to backend
                const response = await fetch(`${apiBaseUrl}/savePackageSelection`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                if (response.ok) {
                    // console.log('Data saved successfully');
                    alert("Applied successfully"); // Success alert
                    // Handle success (e.g., display a success message)
                } else {
                    console.error("Failed to save data");
                    // Handle failure (e.g., display an error message)
                }
            } catch (error) {
                console.error("Error:", error);
                // Handle error
            }
        } else {
            navigate("/packages", {
                state: {
                    job: jobDetails.job,
                    jobId:
                        jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                            ? jobDetails.manualJobID
                            : jobDetails.job_id,
                    location: jobDetails.location,
                },
            });
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!jobId) {
            setError("No job ID provided. Please go back and try again.");
            console.error("jobId is missing or invalid:", jobId);
            return;
        }

        // Safely convert to string and clean
        let cleanedJobId = String(jobId).trim();

        // Remove surrounding quotes if present (e.g., "'123'" → "123")
        cleanedJobId = cleanedJobId.replace(/^['"]+|['"]+$/g, "");

        if (!cleanedJobId) {
            setError("Invalid job ID. Please try again.");
            console.error("cleanedJobId is empty after processing:", jobId);
            return;
        }

        const encodedJobId = encodeURIComponent(cleanedJobId);
        const url = `${apiBaseUrl}/getjobposts/${encodedJobId}`;

        console.log("Fetching job from:", url); // ← Helpful for debugging

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 404) {
                        throw new Error("Job not found. The job may have been deleted or the ID is incorrect.");
                    }
                    throw new Error(`Server error: ${response.status} ${response.statusText}`);
                }
                return response.json();
            })
            .then((data) => {
                // Backend returns a single object (not array), so use directly
                if (data && typeof data === "object") {
                    setJobDetails(data);
                    console.log(data);
                } else {
                    throw new Error("Invalid data received from server");
                }
            })
            .catch((error) => {
                console.error("Error fetching job details:", error);
                setError(error.message || "Failed to load job details. Please try again later.");
            });
    }, [jobId, apiBaseUrl]);

    const downloadStyledImage = () => {
        const container = document.getElementById("jobDetailsContainer");
        container.style.display = "block"; // Show the container temporarily for capture

        // Set the container dimensions to portrait mode for a standard page size
        container.style.width = "800px";
        container.style.height = "1120px";

        // Capture the container with html2canvas
        html2canvas(container, { scale: 2, width: 800, height: 1120 })
            .then((canvas) => {
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                link.download = "job_details.png";
                link.click();

                // Clean up
                container.style.display = "none"; // Hide the container again after download
                container.style.width = ""; // Reset width
                container.style.height = ""; // Reset height
            })
            .catch((error) => {
                console.error("Error capturing image:", error);
            });
    };

    if (error) {
        return <div>{error}</div>; // Show error message
    }

    if (!jobDetails) {
        return <div>Loading job details...</div>; // Loading state
    }

    const editJobPost = () => {
        navigate("/editjobpost", {
            state: {
                jobId: jobDetails.job_id,
                employeeId: jobDetails.employee_id,
                manualJobID:
                    jobDetails.manualJobID && jobDetails.manualJobID !== "0" ? jobDetails.manualJobID : jobDetails.job_id,
                // Optional: pass the full job details if needed in the edit form
                // jobDetails: jobDetails
            },
        });
    };

    return (
        <div className="min-h-screen flex flex-col ">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="flex flex-col gap-8 lg:px-12 px-3 mt-12 pb-12">
                <div className="flex flex-row justify-between w-full">
                    <div
                        className="h-[42px] lg:w-[13%] w-[40%] bg-[#3B3D3B] hover:bg-[#2f302f] rounded-[10px] flex justify-center items-center text-base font-[600] font-display text-[white] cursor-pointer"
                        onClick={handlePackageClick}
                    >
                        Company Details
                    </div>
                    <div
                        className="h-[42px] lg:w-[13%] w-[40%] bg-[#d22989] hover:bg-[#be3683] rounded-[10px] flex justify-center items-center text-lg font-[600] font-display text-[white] cursor-pointer"
                       onClick={editJobPost}
                    >
                        Edit
                    </div>
                    <div
                        className="h-[42px] lg:w-[13%] w-[40%] bg-[#282d55] hover:bg-[#282d55] rounded-[10px] flex justify-center items-center text-lg font-[600] font-display text-[white] cursor-pointer"
                        onClick={downloadStyledImage}
                    >
                        Download
                    </div>
                </div>

                <div className="w-full flex flex-col gap-4">
                    <span className="text-xl font-[700] font-display text-left">{jobDetails.job}</span>
                    <span className="text-lg font-[400] font-display text-left">{jobDetails.job_title}</span>
                    <div className="flex flex-col w-full h-auto gap-2">
                        <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                            <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                <img src={id} alt="loc" />
                                <span className="text-[#B3B3B3] text-lg font-[500] font-display">Job Id</span>
                            </div>
                            <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                {jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                                    ? jobDetails.manualJobID
                                    : jobDetails.job_id}
                            </div>
                        </div>
                        {(selectedPlan === "300" ||
                            selectedPlan === "500" ||
                            selectedPlan === "600" ||
                            selectedPlan === "800" ||
                            selectedPlan === "0" ||
                            customerType === "admin" ||
                            customerType === "mainAdmin") && (
                            <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                    <img src={company} alt="loc" />
                                    <span className="text-[#B3B3B3] text-lg font-[500] font-display">Company Type</span>
                                </div>
                                <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                    {jobDetails.company_type}
                                </div>
                            </div>
                        )}

                        <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                            <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                <img src={suitecase} alt="loc" />
                                <span className="text-[#B3B3B3] text-lg font-[500] font-display">Job Type</span>
                            </div>
                            <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                {jobDetails.job_type}
                            </div>
                        </div>
                        {(selectedPlan === "300" ||
                            selectedPlan === "500" ||
                            selectedPlan === "600" ||
                            selectedPlan === "800" ||
                            selectedPlan === "0" ||
                            customerType === "admin" ||
                            customerType === "mainAdmin") && (
                            <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                    <img src={loc} alt="loc" />
                                    <span className="text-[#B3B3B3] text-lg font-[500] font-display">Location</span>
                                </div>
                                <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                    {jobDetails.location}
                                </div>
                            </div>
                        )}

                        {(selectedPlan === "300" ||
                            selectedPlan === "500" ||
                            selectedPlan === "600" ||
                            selectedPlan === "800" ||
                            selectedPlan === "0" ||
                            customerType === "admin" ||
                            customerType === "mainAdmin") && (
                            <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                    <img src={loc} alt="loc" />
                                    <span className="text-[#B3B3B3] text-lg font-[500] font-display">Address</span>
                                </div>
                                <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                    {jobDetails.address}
                                </div>
                            </div>
                        )}

                        <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                            <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                <img src={loc} alt="loc" />
                                <span className="text-[#B3B3B3] text-lg font-[500] font-display">Vacancy</span>
                            </div>
                            <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                {jobDetails.vacancy}
                            </div>
                        </div>

                        <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                            <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                                <img src={dinner} alt="loc" />
                                <span className="text-[#B3B3B3] text-lg font-[500] font-display">Food & Accomodation</span>
                            </div>
                            <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                {jobDetails.food_type}
                            </div>
                        </div>

                        {/* <div className='flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]'>
                            <div className='lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center'>
                                <img src={rs} alt="loc" />
                                <span className='text-[#B3B3B3] text-lg font-[500] font-display'>Monthly Salary</span>
                            </div>
                            <div className='lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display'>
                                {jobDetails.min_salary > 0 && jobDetails.max_salary > 0
                                    ? `₹ ${jobDetails.min_salary} - ₹ ${jobDetails.max_salary}`
                                    : jobDetails.min_salary > 0
                                        ? `₹ ${jobDetails.min_salary}`
                                        : jobDetails.max_salary > 0
                                            ? `₹ ${jobDetails.max_salary}`
                                            : null}
                            </div>
                        </div> */}

                        {(selectedPlan === "300" ||
                            selectedPlan === "500" ||
                            selectedPlan === "600" ||
                            selectedPlan === "800" ||
                            selectedPlan === "0" ||
                            customerType === "admin" ||
                            customerType === "mainAdmin") && (
                            <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                                <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3 items-center">
                                    <img src={phone} alt="loc" />
                                    <span className="text-[#B3B3B3] text-lg font-[500] font-display">Manager Number</span>
                                </div>
                                <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                                    {jobDetails.whatsapp_number}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ul className="border-2 border-[#E3EAF1]"></ul>
                <div className="flex flex-col w-full gap-4">
                    <span className="text-xl font-[700] font-display text-left">Job Description</span>
                    <span className="text-lg font-[400] font-display text-left">{jobDetails.job_description}</span>
                </div>
                <span className="text-xl font-[700] font-display text-left">Requirements</span>

                <div className="flex flex-col w-full h-auto gap-2">
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Required Gender</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.gender_type}
                        </div>
                    </div>

                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Qualification</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.qualification}
                        </div>
                    </div>
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Min salary</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.min_salary}
                        </div>
                    </div>
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Max Salary</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.max_salary}
                        </div>
                    </div>
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Start Time</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.start_time}
                        </div>
                    </div>
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">End Time</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.end_time}
                        </div>
                    </div>
                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Experience Type</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.experienceType}
                        </div>
                    </div>

                    <div className="flex lg:flex-row flex-col lg:h-[56px] h-[70px] w-full border-2 border-[#E3EAF1] rounded-[10px]">
                        <div className="lg:w-[30%] w-full h-full lg:border-r-2 border-b-2 border-[#E3EAF1] flex flex-row px-5 gap-3  items-center">
                            <span className="text-[#B3B3B3] text-lg font-[500] font-display">Salary Type</span>
                        </div>
                        <div className="lg:w-[70%] w-full h-full flex items-center px-5 text-lg font-[500] font-display">
                            {jobDetails.salaryType}
                        </div>
                    </div>
                </div>
            </div>

            <div id="jobDetailsContainer" style={{ display: "none", height: "100vh", width: "100vw" }}>
                <div className="flex flex-row w-[100%]  h-[100%] ">
                    <div className="px-3 w-full  flex flex-col">
                        <div className="w-[90%] h-auto bg-[white]  py-6 flex flex-col gap-5 ">
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display text-left">
                                Job : <span>{jobDetails.job}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Job ID :{" "}
                                <span>
                                    {jobDetails.manualJobID && jobDetails.manualJobID !== "0"
                                        ? jobDetails.manualJobID
                                        : jobDetails.job_id}
                                </span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Job Title : <span>{jobDetails.job_title}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Salary :
                                <span>
                                    {jobDetails.min_salary > 0 && jobDetails.max_salary > 0
                                        ? `${jobDetails.min_salary} - ${jobDetails.max_salary}`
                                        : jobDetails.min_salary > 0
                                        ? jobDetails.min_salary
                                        : jobDetails.max_salary > 0
                                        ? jobDetails.max_salary
                                        : jobDetails.salaryType}
                                </span>
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Company Type : <span>{jobDetails.company_type}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Qualification : <span>{jobDetails.qualification}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Required Gender : <span>{jobDetails.gender_type}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Location : <span>{jobDetails.location}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Job Type : <span>{jobDetails.job_type}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Address : <span>{jobDetails.address}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Vacancy : <span>{jobDetails.vacancy}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Food & Accomodation : <span>{jobDetails.food_type}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Manager Number : <span>{jobDetails.whatsapp_number}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Job Description : <span>{jobDetails.job_description}</span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Timing :{" "}
                                <span>
                                    {jobDetails.start_time} - {jobDetails.end_time}
                                </span>{" "}
                            </span>
                            <span className="flex flex-row gap-3 font-[600] text-2xl font-display">
                                Experience Type : <span>{jobDetails.experienceType}</span>{" "}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-12">
                <Footer />
            </div>
        </div>
    );
}

export default DetailsForStaff;
